import React, { useEffect, useState } from "react";

import { getLoginInfo, setSearchInfo } from '../../../shared/utils/storage';
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import { useNavigate } from "react-router-dom";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { createNotification } from '../../../shared/components/Popup';
import { generatePDF } from "../../../shared/services/listReport";

function SharedTable({ userData, pageName }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [userName, setUserName] = useState();
  const [loading, setLoading] = useState([]);
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [applications, setApplications] = useState([]);
  const [pdfBase64, setPdfBase64] = useState("");
  useEffect(() => {
    handleDataPool();
  }, []);

  async function handleDataPool() {
    try {
      userData && setData(userData);
      data &&
        $(document).ready(function () {
          $("#example").DataTable();
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
    }
  }

  const viewApplicationsDetails = async (applicationID, index) => {
    const newLoading = [...loading];
    newLoading[index] = true;
    setLoading(newLoading);

    const payload = {
      ApplicationId: applicationID,
      UserName: getLoginInfo()?.user?.Username,
      StageId: "",
      Station: getLoginInfo()?.user?.StationID,
      Action: "View",
      AccessorId: getLoginInfo()?.user?.UserID,
    };

    try {
      const result = await handleApplicationManagement(
        payload,
        "application_management",
      );

      newLoading[index] = false;
      setLoading(newLoading);

      if (result?.code == 1) {
        //  navigate('/viewSearchedDetails', { state: result.data });
        const response = {
          data: result.data,
          pageFrom: "Enquiry",
        };
        setSearchInfo(response);
        navigate("/viewSearchedDetails");
      } else {
        setApplications(null);
        const info = { type: "error", message: result?.message };
        createNotification(info)();
      }
    } catch (error) {
      console.error("Error handling application:", error);

      // Ensure loading is set to false in case of an error
      newLoading[index] = false;
      setLoading(newLoading);
    }
  };

  const pdfGenerationManager = async (data, reportType) => {
    const newData = await generatePDF(data, reportType);
    setPdfBase64(newData);
  };

  const styles = {
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    loadingImage: {
      width: "70px",
      height: "70px",
    },
    td: {
      textAlign: "center",
    },
  };

  return (
    <>
      <div className="row">
        <div className="container">
          <table id="example" className="table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={styles.td}>S/no.</th>
                <th>ApplicationID</th>
                <th>Fullname</th>
                <th>Mobile</th>
                <th>Station</th>
                <th>Status</th>
                <th style={styles.td}>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 &&
                data.map((user, i) => (
                  <tr key={i}>
                    <td style={styles.td}>{i + 1}</td>
                    <td>{user?.ApplicationID}</td>
                    <td>{user?.FullName}</td>
                    <td>{user?.MobileNo}</td>
                    <td>{user?.ReceivedStation}</td>
                    <td>{user?.DocStageName}</td>
                    <td style={styles.td}>
                      <button
                        className=" btn-info"
                        onClick={() =>
                          viewApplicationsDetails(user?.ApplicationID, i)
                        }
                      >
                        <i className="fa fa-eye"></i> | View
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default SharedTable;
